import getPublicUrl from '@/helpers/utils/routing/getPublicUrl'
import { PageProps } from '@/types'
import { toPathFactory } from '@/helpers/utils/routing/toPathFactories'
export const pageUrl = '/[locale]/streambot/fundraising-events/[slug]/total?token&subtractCents'
export const getPageUrl = toPathFactory(pageUrl, getPublicUrl)
export type StreambotTotalPageProps = PageProps<
  typeof pageUrl,
  { token?: string; preview?: 'true' | ''; subtractCents?: string }
>
